import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", { d: "M10.419 8.256a3.483 3.483 0 0 0 1.072-2.508V3.87a3.492 3.492 0 0 0-6.982 0v1.878c0 .984.413 1.869 1.072 2.508a6.25 6.25 0 0 0-3.825 5.752v.875c0 .403.334.738.737.738h11.013a.743.743 0 0 0 .738-.738v-.875a6.25 6.25 0 0 0-3.825-5.752ZM5.984 5.748V3.87c0-1.111.905-2.016 2.016-2.016s2.016.905 2.016 2.016v1.878A2.019 2.019 0 0 1 8 7.764a2.019 2.019 0 0 1-2.016-2.016Zm6.785 8.398H3.23v-.138A4.78 4.78 0 0 1 8 9.239a4.78 4.78 0 0 1 4.769 4.769v.138Z" }, null, -1), a = [
  n
];
function r(s, v) {
  return e(), t("svg", c, [...a]);
}
const l = { render: r };
export {
  l as default,
  r as render
};
